
import React from "react";
import Header from "./Header/header";
import Main from "./Main/main";

function Requests() {
  return (
    <div>
      <Header />
      <Main />
    </div>
  );
}

export default Requests;
